<template>
  <div class="callback">
    <v-container container--fluid grid-list-xl>
      <v-row class="justify-center">
        <v-col cols="12" md="8" sm="6">
          <img class="center" src="https://media.giphy.com/media/ExfivRRI8U4ko/giphy.gif" v-if="!error">
          <div v-else class="display-1 text-center" style="color: black">
          <span>{{ errorMessage }}</span>
            <v-btn text to="/login" color="blue darken-1" @click="auth.logout('login')">
              Go back to the login page
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';

    const {mapActions: authActions} = createNamespacedHelpers("auth");

    export default {
        name: 'Callback',
        data() {
            return {
                error: false,
                errorMessage: 'Sorry, we haven\'t been able to log you in.',
                redirectPath: '',
            }
        },
        async beforeMount() {
            let vars = this.getVars();
            if (vars['code'] !== undefined) {
                if (await this.google_login({
                    redirect_url: window.location.href.split('/callback')[0] + '/callback',
                    code: vars['code']
                })) {
                    let path = this.$store.getters['auth/redirect_url'];
                    console.log("Redirect to: " + path);
                    this.$store.commit('auth/setRedirect', null);
                    window.location.replace(path);
                } else {
                    this.alert = true;
                }
            }
        },
        methods: {
            ...authActions([
                'google_login'
            ]),
            getVars() {
                let vars = {};
                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                    vars[key] = value;
                });
                return vars;
            }
        }
    }
</script>

<style scoped>
  .callback {
    width: 100%;
    text-align: center;
  }

  #title {
    width: 600px;
    max-width: 90%;
    margin-top: 3em;
  }

  #loading {
    width: 500px;
    max-width: 90%;
    margin: auto;
  }

  .center {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/Callback.vue